class TestimonialVideosScroller extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prev = this.querySelector('[data-prev]');
    this.next = this.querySelector('[data-next]');
    if (!this.track) return;

    this.onScroll = () => this.update();
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.resizeObserver = new ResizeObserver(this.onScroll);
    this.resizeObserver.observe(this.track);

    this.prev?.addEventListener('click', () => this.scrollByCard(-1));
    this.next?.addEventListener('click', () => this.scrollByCard(1));
    this.update();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }

  isRTL() {
    return getComputedStyle(this.track).direction === 'rtl';
  }

  scrollByCard(direction) {
    const item = this.track.querySelector('[data-item]');
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 14;
    const step = (item ? item.getBoundingClientRect().width : 260) + gap;
    // In RTL, scrollLeft runs 0 -> -max instead of 0 -> max, so "next" has
    // to move the scroll position in the opposite signed direction.
    const signed = this.isRTL() ? -direction : direction;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({ left: signed * step, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  update() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    this.toggleAttribute('data-overflow', max > 2);
    // scrollLeft ranges 0..max in LTR and 0..-max in RTL; using the absolute
    // distance scrolled from the start keeps this direction-agnostic.
    const offset = Math.abs(this.track.scrollLeft);
    if (this.prev) this.prev.disabled = offset <= 2;
    if (this.next) this.next.disabled = offset >= max - 2;
  }
}

if (!customElements.get('testimonial-videos-scroller')) {
  customElements.define('testimonial-videos-scroller', TestimonialVideosScroller);
}
